import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

import Banner from '../components/layout/Banner';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10)
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <>
      <Banner userId='' />
      <div className={classes.root}>
        <Container>
          <h3 style={{ paddingBottom: '16px' }}>Sorry, Page not Found.</h3>
          <div className={classes.button}><Button color="primary" variant="contained" href="https://www.aist.asn.au/Events/ASI" target="_blank">return to ASI</Button></div>
        </Container>
      </div>
    </>
  );
};